<template>
  <button class="btn-focus" @click="focusGraph">
    <Focus />
  </button>
</template>

<script>
import Focus from "./svg/Focus.vue";

export default {
  components: {
    Focus
  },
  methods: {
    focusGraph() {
      this.graph.centerAt(0, 0, 200);
      this.graph.zoomToFit(200, 50);
    }
  },
  computed: {
    graph() {
      return this.$store.state.graph;
    }
  }
};
</script>

<style>
.btn-focus {
  background-color: #07689f;
  box-shadow: 0 0 5px rgba(57, 63, 72, 0.3);
  @apply right-0 mr-2 fixed bottom-0
  p-2 mb-2 h-10 w-10 z-10 fill-gray-100
  rounded-full;
}

@screen md {
  .btn-focus {
    @apply mb-3 mr-3 h-12 w-12 p-3;
  }
}
</style>
